<div class="annunciator-container">
    <div class="machines-grid" *ngIf="isData; else elseTemplate">
      <div *ngFor="let machineId of machines | keyvalue" class="machine-card">
        <div class="machine-header">
          <span class="machine-title">MACHINE {{ machineId.key }}</span>
          <span class="machine-status-indicator"></span>
        </div>
        <div class="machine-divider"></div>
        <div class="windows-grid">
          <div *ngFor="let window of machineId.value.data | keyvalue" class="window-item">
            <div class="window-status" [class.active]="window.value != 0">
              <span class="window-name" (click)="startEditing(machineId.key, window.key)">
                {{ windowNames[machineId.key][window.key] }}
              </span>
              <input *ngIf="editingWindow === window.key" type="text" [value]="windowNames[machineId.key][window.key]"
                (blur)="updateWindowName(machineId.key, window.key, $event.target.value)"
                (keyup.enter)="updateWindowName(machineId.key, window.key, $event.target.value)" class="window-name-edit"
                autofocus>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ng-template #elseTemplate>
        No Data found
      </ng-template>
  </div>